<router-outlet></router-outlet>
<div class="main-body">
  <div class="row gutters-sm">
    <!--     Profile  options card-->
    <div class="col-md-4 mb-5">
      <div class="card">
        <div class="d-block d-md-none">
          <a class="float-end m-2" role="button" (click)="openDialog()">
            <i class="pi pi-pen-to-square text-danger"></i> Edit
          </a>
        </div>
        <div class="card-body">
          <div class="d-flex flex-column align-items-center text-center">
            <input #fileInput type="file" id="profilePicture" class="d-none" (change)="onFileSelected($event)"/>
            <img [src]="customer.profileImageUrl || 'https://bootdey.com/img/Content/avatar/avatar7.png'" alt="Image" class="rounded-circle" width="120" height="120" (click)="triggerFileInput()">
            <div class="mt-3">
              <h4>{{ customer.firstName+" "+customer.lastName }}</h4>
            </div>
          </div>
          <hr>
          <div *ngFor="let tab of tabs" class="payBtn-mk">
            <a role="button" (click)="navigateToTab(tab)">
              <div class="row bg-white py-3 px-2 border-bottom">
                <div class="col-3 my-auto">
                  <i class="{{tab.icon}} fs-5 text-secondary"></i>
                </div>
                <div class="col-7 px-0 my-auto">
                  <div class="fs-14 fw-bold">{{ tab.label }}</div>
                </div>
                <div class="col-1 my-auto">
                  <i class="pi pi-chevron-right fs-5 text-secondary"></i>
                </div>
              </div>
            </a>
            <div *ngIf="tab.expanded">
              <div *ngFor="let child of tab.items" class="child-item ms-2">
                <a role="button" (click)="navigateToTab(child)">
                  <div class="row bg-light py-2 px-2 border-bottom">
                    <div class="col-3 my-auto">
                      <i class="{{child.icon}} fs-5 text-secondary"></i>
                    </div>
                    <div class="col-7 px-0 my-auto">
                      <div class="fs-14 fw-bold fw-light">{{ child.label }}</div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div class="payBtn-mk">
            <a role="button" (click)="logOut()">
              <div class="row bg-white py-3 px-2 border-bottom">
                <div class="col-3 my-auto">
                  <i class="pi pi-sign-out fs-5 text-secondary"></i>
                </div>
                <div class="col-7 px-0 my-auto">
                  <div class="fs-14 fw-bold">Log Out</div>
                </div>
                <div class="col-1 my-auto">
                  <i class="pi pi-chevron-right fs-5 text-secondary"></i>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-8 d-none d-md-block">
      <div class="row gutters-sm">
        <div class="col-md-6 w-100 w-md-auto">
        <app-user-profile/>
          </div>
        <!--        Recent Orders-->
        <div class="col-md-6 w-100 w-md-auto px-5">
          <h3 class="fw-bold text-center py-4">Recent Orders</h3>
          <app-recently-order></app-recently-order>
        </div>
      </div>
    </div>
  </div>
</div>
    <p-dialog header="Edit Your Profile" [modal]="true" [(visible)]="visible" [style]="{ width: '40rem' }">
      <div class="container p-3" style="max-width: 600px;">
        <form *ngIf="editModal" class="text-black">
          <div class="mb-4">
            <label for="name" class="form-label fw-bold fs-6">Full Name</label>
            <input id="name" class="form-control fs-6" required name="name" [readOnly]="isNameFilled()" value="{{ customer.firstName }} {{ customer.lastName }}" placeholder="Full Name"/>
          </div>
          <div class="mb-4">
            <label for="email" class="form-label fw-bold fs-6">Email</label>
            <input id="email" class="form-control fs-6" required name="email" [(ngModel)]="customer.emailId" placeholder="Email"/>
          </div>
          <div class="mb-4">
            <label for="gender" class="form-label fw-bold fs-6">Gender</label>
            <select id="gender" class="form-select fs-6" name="Gender" [(ngModel)]="customer.gender">
              <option value="" disabled>Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>
          <div class="mb-4">
            <label for="dob" class="form-label fw-bold fs-6">Date of Birth</label>
            <input id="dob" type="date" class="form-control fs-6" name="dob" [(ngModel)]="customer.dob"/>
          </div>
          <div class="d-flex justify-content-center mt-4">
            <button class="btn btn-danger px-4 py-2 fs-6 fw-bold" (click)="submitForm()">
              Update
            </button>
          </div>
        </form>
      </div>
    </p-dialog>
<p-dialog header="Change Your Password" [modal]="true" [(visible)]="changeModal" [style]="{ width: '40rem' }">
  <div class="container p-3" style="max-width: 600px;">
    <h2 class="text-center mb-4">Change Password</h2>
    <div *ngIf="changeModal" class="d-flex flex-column">
      <form (submit)="changePassword()" class="w-100">
        <div class="mb-4">
          <label for="oldPassword" class="form-label fw-bold fs-6">Old Password <span class="text-danger">*</span></label>
          <div class="input-group">
            <input [type]="showOldPassword ? 'text' : 'password'" id="oldPassword" name="oldPassword" class="form-control fs-6" required [(ngModel)]="user.oldPassword" placeholder="Old Password"/>
            <span class="input-group-text" (click)="toggleOldPasswordVisibility()">
              <i [class]="showOldPassword ? 'pi pi-eye' : 'pi pi-eye-slash'"></i>
            </span>
          </div>
        </div>
        <div class="mb-4">
          <label for="newpassword" class="form-label fw-bold fs-6">New Password <span class="text-danger">*</span></label>
          <div class="input-group">
            <input [type]="showNewPassword ? 'text' : 'password'" id="newpassword" name="password" class="form-control fs-6" required [(ngModel)]="user.password" placeholder="New Password"/>
            <span class="input-group-text" (click)="toggleNewPasswordVisibility()">
              <i [class]="showNewPassword ? 'pi pi-eye' : 'pi pi-eye-slash'"></i>
            </span>
          </div>
          <small class="text-danger">Password must contain at least one number and one alphabet.</small>
        </div>
        <div class="mb-4">
          <label for="confirmPassword" class="form-label fw-bold fs-6">Confirm New Password <span class="text-danger">*</span></label>
          <div class="input-group">
            <input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword" name="confirmPassword" class="form-control fs-6" required [(ngModel)]="user.confirmPassword" placeholder="Confirm New Password"/>
            <span class="input-group-text" (click)="toggleConfirmPasswordVisibility()">
              <i [class]="showConfirmPassword ? 'pi pi-eye' : 'pi pi-eye-slash'"></i>
            </span>
          </div>
          <small *ngIf="user.password!=user.confirmPassword && user.confirmPassword.length>0" class="text-danger">Password do not match with the new password</small>
        </div>
        <div class="d-flex justify-content-center mt-4">
          <button type="submit" class="btn btn-danger px-4 py-2 fs-6 fw-bold">Submit</button>
        </div>
      </form>
    </div>
  </div>
</p-dialog>
